import type { DashboardGroup, SidebarButton } from './types.d.ts';

/** Sidebar quick-action buttons */
export const sidebarButtons: SidebarButton[] = [
  { label: 'Database', href: '/database' },
  { label: 'Teacher Database', href: '/teacher' },
  { label: 'Data Print', href: '/data_print' },
  { label: 'Data Edit Colm', href: '/data_edit' },
  { label: 'Other School', href: '/other_school_dashboard' },
];

/** Main dashboard groups (admin-dashboard.html buttons) */
export const mainGroups: DashboardGroup[] = [
  {
    title: 'Data Management',
    pill: 'Core',
    links: [
      {
        label: 'Database 2026',
        href: '/database',
        badge: 'working',
        badgeClass: 'badge-orange',
      },
      {
        label: 'Active Student Update',
        href: '/active_student_update',
        badge: 'New',
        badgeClass: 'badge-orange',
      },
      {
        label: 'Edit by IID',
        href: '#',
        badge: 'New',
        badgeClass: 'badge-orange',
        icon: '📝',
      },
      {
        label: 'Reg Form',
        href: '/reg_dashboard',
        badge: 'New',
        badgeClass: 'badge-orange',
      },
      {
        label: 'Other School',
        href: '/other_school_dashboard',
        badge: 'New',
        badgeClass: 'badge-orange',
        icon: '🏫',
      },
    ],
  },
  {
    title: 'Old Data',
    pill: 'Archive',
    links: [
      {
        label: 'Database 2025',
        href: '/database_2025',
        badge: 'working',
        badgeClass: 'badge-orange',
      },
      {
        label: 'Database 2024',
        href: '#',
        badge: 'working',
        badgeClass: 'badge-orange',
      },
      {
        label: 'Database 2023',
        href: '#',
        badge: 'working',
        badgeClass: 'badge-orange',
      },
      {
        label: 'Database 2022',
        href: '#',
        badge: 'working',
        badgeClass: 'badge-orange',
      },
      {
        label: 'Previous data - till June 2025',
        href: '/database_old',
        badgeClass: 'badge-orange',
      },
    ],
  },
  {
    title: 'Add New',
    pill: 'Create',
    links: [
      {
        label: 'Add New Student',
        href: '/addstudent',
        icon: '👤',
      },
      {
        label: 'Add New Teacher',
        href: '/addteacher',
        icon: '👨‍🏫',
      },
      {
        label: 'Add student from Admission',
        href: '/admission',
        icon: '📄',
      },
      {
        label: 'Class Access Control (শ্রেণি শিক্ষক)',
        href: '/class_control',
        icon: '🔒',
      },
      {
        label: 'Photo Backup',
        href: '/image_backup',
        icon: '🖼️',
        badge: 'New',
        badgeClass: 'badge-orange',
      },
    ],
  },
  {
    title: 'Exam Tools',
    pill: 'Tools',
    links: [
      {
        label: 'Promotion',
        href: '/promotion',
        badge: 'New',
        badgeClass: 'badge-orange',
      },
      {
        label: 'Seat Plan Pro',
        href: '/seat_plan_pro',
        badge: 'New',
        badgeClass: 'badge-orange',
        icon: '📋',
      },
      {
        label: 'Student login ID',
        href: '/student_log_in',
        badge: 'New',
        badgeClass: 'badge-orange',
        icon: '🔑',
      },
    ],
  },
];

/** Other School sub-buttons (from z_others) */
export const otherSchoolGroups: DashboardGroup[] = [
  {
    title: 'Other School',
    pill: 'External',
    links: [
      {
        label: 'Student Database',
        href: '/other_school/database',
        icon: '📚',
        badge: 'Active',
        badgeClass: 'badge-orange',
      },
      {
        label: 'New Admission',
        href: '/other_school/admission',
        icon: '📝',
      },
      {
        label: 'Edit Admission Form',
        href: '/other_school/edit_application',
        icon: '✏️',
      },
      {
        label: 'Result Entry',
        href: '/other_school/result_entry',
        icon: '📊',
      },
      {
        label: 'Result Entry (9, 10)',
        href: '/other_school/result_entry_9',
        icon: '📊',
      },
      {
        label: 'School Login (Others)',
        href: '/other_school/login',
        icon: '🔑',
      },
      {
        label: 'Other School Dashboard',
        href: '/other_school_dashboard',
        icon: '🏫',
      },
      {
        label: 'Transfer Certificate (TC)',
        href: '/other_school/tc/tc_edit_form',
        icon: '📄',
      },
      {
        label: 'Download Form',
        href: '/other_school/download_form',
        icon: '⬇️',
      },
      {
        label: 'Result (Others)',
        href: '/other_school/result/list',
        icon: '📋',
      },
      {
        label: 'Result (9-10)',
        href: '/other_school/result/list_9',
        icon: '📋',
      },
    ],
  },
];
